import { useTranslation } from 'react-i18next';

import styles from './FooterLayout.module.scss';

const FooterLayout = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <div className={styles.footerLayout}>
      <ul className={styles.footerMenu}>
        <li>© {currentYear} Cyclomedia</li>
        <li>
          <a href="https://www.cyclomedia.com/us/support/contactservice-desk">{t('contact')}</a>
        </li>
      </ul>
    </div>
  );
};

export default FooterLayout;
